import { queryOptions } from "@tanstack/react-query";
import { getDirectoryConfigurations } from "api/directoryConfigurations";

const DIRECTORY_CONFIGURATIONS_QUERY_KEY = "directoryConfigurations";

export const directoryConfigurationsQuery = () =>
  queryOptions({
    queryFn: () => getDirectoryConfigurations(),
    queryKey: [DIRECTORY_CONFIGURATIONS_QUERY_KEY],
  });
